export const NODE_NAME = 'check_list_item';
